/**
 * Recarga de datos cuando el usuario pulsa Actualizar en la barra izquierda.
 */
import { useEffect } from 'react';
import { ANALYTICS_REFRESH_EVENT } from '../utils/session-cache.js';

/**
 * @param {() => void} onRefresh
 */
export function useAnalyticsRefresh(onRefresh) {
  useEffect(() => {
    if (typeof onRefresh !== 'function') return undefined;
    const handler = () => {
      onRefresh();
    };
    window.addEventListener(ANALYTICS_REFRESH_EVENT, handler);
    return () => window.removeEventListener(ANALYTICS_REFRESH_EVENT, handler);
  }, [onRefresh]);
}
